const translations = {
  title: "Manufacturing Bills",
  subtitle: "Karigar gold accounts — gold given, received, and closing balances.",
  newBill: "New Manufacturing Bill",
  billNo: "Bill No.",
  billDate: "Date",
  billDetail: "Bill Detail",
  billNotFound: "Manufacturing bill not found.",
  // Fields
  karigar: "Karigar",
  karigarName: "Karigar Name",
  goldGiven: "Gold Given (g)",
  goldReceived: "Gold Received (g)",
  scrapReceived: "Scrap Received (g)",
  wastage: "Wastage (g)",
  closingBalance: "Closing Balance (g)",
  purity: "Purity",
  period: "Period",
  periodFrom: "From",
  periodTo: "To",
  // Status
  status_open: "Open",
  status_settled: "Settled",
  status_draft: "Draft",
  // Actions
  createBill: "Create Bill",
  printBill: "Print Manufacturing Bill",
  settleBill: "Mark as Settled",
  // Summary
  totalGoldGiven: "Total Gold Given",
  totalGoldReceived: "Total Gold Received",
  totalWastage: "Total Wastage",
  netBalance: "Net Balance",
  // Gold issue lines
  issueLines: "Gold Issue Lines",
  addIssueLine: "Add Issue Line",
  issueDate: "Issue Date",
  issueWeight: "Weight (g)",
  issuePurity: "Purity",
  issueRef: "Job Card / Ref",
  // Return lines
  returnLines: "Return Lines",
  addReturnLine: "Add Return Line",
  returnDate: "Return Date",
  returnGrossWt: "Gross Wt (g)",
  returnFineWt: "Fine Wt (g)",
  returnType: "Type",
  return_finished: "Finished Item",
  return_scrap: "Scrap",
  return_dust: "Dust / Sweepings",
  // Empty states
  noBills: "No manufacturing bills yet.",
  createFirst: "Create the first bill to track karigar gold.",
  // Columns
  col_billNo: "Bill No.",
  col_karigar: "Karigar",
  col_period: "Period",
  col_given: "Given",
  col_received: "Received",
  col_balance: "Balance",
  col_status: "Status",
  col_action: "Action",
};

export default translations;
